export const LOADING_MATRIZ_EVALUACION_PUESTO =
  "LOADING_MATRIZ_EVALUACION_PUESTO";
export const SAVE_LOADING_MATRIZ_EVALUACION_PUESTO =
  "SAVE_LOADING_MATRIZ_EVALUACION_PUESTO";
export const GET_MATRIZ_EVALUACION_PUESTO = "GET_MATRIZ_EVALUACION_PUESTO";
export const FORM_FAIL = "FORM_FAIL";
export const MATRIZ_EVALUACION_PUESTO_FAIL = "MATRIZ_EVALUACION_PUESTO_FAIL";
export const LOADING_MODAL_MATRIZ_EVALUACION = "LOADING_MODAL_MATRIZ_EVALUACION"
export const GET_MODAL_MATRIZ_EVALUACION = "GET_MODAL_MATRIZ_EVALUACION"
export const MODAL_MATRIZ_EVALUACION_FAIL = "MODAL_MATRIZ_EVALUACION_FAIL";
